import React, { useState } from 'react';
import PropTypes from 'prop-types';

import RegisterMemberModal from 'components/register-member-modal';

// The "Bli medlem" entry point. Editors place this block anywhere; clicking it
// opens the shared choice modal (BankID / manuell registrering). The modal itself
// lives in components/register-member-modal so the floating support button can
// reuse it.
const RegisterMemberCta = ({ buttonText, modalTitle, campaignCode }) => {
  const [open, setOpen] = useState(false);

  // CMS sends null/empty when the editor leaves the field blank (the page-prop
  // serializer doesn't omit nulls, so defaultProps alone wouldn't catch them).
  const label = buttonText || 'Bli medlem';
  const title = modalTitle || 'Bli medlem';
  // Optional campaign code (kampanjekode). When the editor sets it on a campaign
  // page's CTA, it's carried into the form as ?kode= so the registration is stamped
  // with it. Blank ⇒ no code (normal registration).
  const code = campaignCode || null;

  return (
    <div className="register-member-cta">
      <button
        type="button"
        className="register-member-cta__button register-member-cta__button--primary"
        onClick={() => setOpen(true)}
      >
        <span className="register-member-cta__label">{label}</span>
      </button>

      <RegisterMemberModal
        open={open}
        onClose={() => setOpen(false)}
        title={title}
        campaignCode={code}
      />
    </div>
  );
};

RegisterMemberCta.defaultProps = {
  buttonText: 'Bli medlem',
  modalTitle: 'Bli medlem',
  campaignCode: null
};

RegisterMemberCta.propTypes = {
  buttonText: PropTypes.string,
  modalTitle: PropTypes.string,
  campaignCode: PropTypes.string
};

export default RegisterMemberCta;
